import {FC, ChangeEvent, useCallback} from 'react';
import {styled} from 'styled-components';

import {LIGHT_GRAY_COLOR, MAIN_COLOR} from '@mavismart_frontend/lib/constants';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const ToggleSwitch: FC<ToggleSwitchProps> = ({checked, onChange}) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.checked);
    },
    [onChange]
  );

  return (
    <Label>
      <HiddenCheckbox type="checkbox" checked={checked} onChange={handleChange} />
      <Switch checked={checked} />
    </Label>
  );
};

ToggleSwitch.displayName = 'ToggleSwitch';

const Label = styled.label`
  cursor: pointer;
`;

const HiddenCheckbox = styled.input.attrs({type: 'checkbox'})`
  opacity: 0;
  position: absolute;
`;

const Switch = styled.div<{checked: boolean}>`
  position: relative;
  width: 40px;
  height: 20px;
  background: ${props => (props.checked ? `${MAIN_COLOR}` : `${LIGHT_GRAY_COLOR}`)};
  border-radius: 32px;
  padding: 4px;
  transition: background 0.3s;

  &:before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: white;
    top: 4px;
    left: ${props => (props.checked ? '24px' : '4px')};
    transition: left 0.3s;
  }
`;
